import * as React from 'react'

import Panel from './Panel'
import Tab from './Tab'
import * as styles from './index.vanilla.css'
import { TabType } from './types'

interface Props<TabIds> {
  selectedTab?: TabType<TabIds>
  tabs: Array<TabType<TabIds>>
  // FIXME will change when we come up with a new solution for modifying common components
  marginLeft?: boolean
  onClick?: (selectedTab: TabType<TabIds>) => void
}

interface ChildrenProps<TabIds> {
  tab: TabType<TabIds>
  isSelected: boolean
}

function Tabs<TabIds>(props: Props<TabIds> & React.ConsumerProps<ChildrenProps<TabIds>>) {
  const { tabs, children, marginLeft, selectedTab: selectedTabProp, onClick } = props
  const [selectedTab, setSelectedTab] = React.useState<TabType<TabIds> | null | undefined>(null)

  const isSelected = React.useCallback(
    (tab: TabType<TabIds>): boolean => {
      return (selectedTabProp || selectedTab || tabs[0]!).id === tab.id
    },
    [selectedTabProp, selectedTab, tabs]
  )

  const handleClick = React.useCallback(
    (selectedTab: TabType<TabIds>) => {
      setSelectedTab(selectedTab)
      onClick && onClick(selectedTab)
    },
    [onClick]
  )

  return (
    <>
      <div className={`${styles.tabs} ${marginLeft ? 'marginLeft' : ''}`} role="tablist">
        {tabs.map((tab) => (
          <Tab tab={tab} isSelected={isSelected(tab)} onClick={handleClick} key={`tab_${tab.id}`} />
        ))}
      </div>
      {tabs.map((tab) => children({ tab, isSelected: isSelected(tab) }))}
    </>
  )
}

Tabs.Panel = Panel

export default Tabs
